import DocumentationButton from "components/DocumentationButton";
import Box from "ds/components/Box";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerFooter from "ds/components/Drawer/Footer";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import Typography from "ds/components/Typography";
import { AnalyticsPagePersonal } from "hooks/useAnalytics/pages/personal";
import { getDocsUrl } from "utils/getDocsUrl";

import styles from "./styles.module.css";

const PersonalSettingsApiKeysInfoDrawer = createDrawer(() => {
  return (
    <DrawerSimple isDismissable>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="Personal API keys" />
        <DrawerCloseIcon />
      </DrawerHeader>
      <DrawerBody>
        <Box direction="column" gap="large" margin="0 0 large 0">
          <Typography tag="p" variant="p-body2">
            A personal API key belongs to you, not to the organization. Use it with spacectl,
            Terraform or your own scripts to act as yourself in Spacelift.
          </Typography>

          <Box direction="column" gap="small">
            <Typography tag="h3" variant="p-t6">
              How access works
            </Typography>
            <Typography tag="p" variant="p-body2">
              The key has no roles of its own. Each time it’s used, it gets the roles you hold at
              that moment, assigned to you directly or through your IdP groups. It can never do more
              than you can. If you lose a role or your user is deprovisioned, your keys lose that
              access too.
            </Typography>
          </Box>

          <Box direction="column" gap="small">
            <Typography tag="h3" variant="p-t6">
              Good to know
            </Typography>
            <Typography tag="div" variant="p-body2">
              <ul className={styles.list}>
                <li>
                  The secret is in a credentials file your browser downloads once. If you lose it,
                  reset the key or create a new one.
                </li>
                <li>Every key has an expiry date, up to 180 days ahead.</li>
                <li>
                  A personal key can’t create API keys, change role bindings or sign in to the web
                  UI.
                </li>
              </ul>
            </Typography>
          </Box>

          <Typography tag="p" variant="p-body2">
            For CI or anything your team depends on, use an organization API key instead.
          </Typography>
        </Box>
        <DrawerFooter>
          <DocumentationButton
            to={getDocsUrl("/integrations/personal-api-keys.html")}
            analyticsPage={AnalyticsPagePersonal.PersonalApiKeys}
          />
        </DrawerFooter>
      </DrawerBody>
    </DrawerSimple>
  );
});

export const showPersonalSettingsApiKeysInfoDrawer = createDrawerTrigger(
  PersonalSettingsApiKeysInfoDrawer
);
